import { render, staticRenderFns } from "./your-account-1.vue?vue&type=template&id=7538e6a0&"
import script from "./your-account-1.vue?vue&type=script&lang=ts&"
export * from "./your-account-1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports